/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as PantryRouteRouteImport } from './routes/pantry/route'
import { Route as RecipesRouteRouteImport } from './routes/recipes/route'
import { Route as SettingsRouteImport } from './routes/settings'
import { Route as ListListIdRouteImport } from './routes/list/$listId'
import { Route as PantryIndexRouteImport } from './routes/pantry/index'
import { Route as PantrySearchRouteImport } from './routes/pantry/search'
import { Route as RecipesIndexRouteImport } from './routes/recipes/index'
import { Route as RecipesSlugRouteRouteImport } from './routes/recipes/$slug/route'
import { Route as RecipesPublishedRouteImport } from './routes/recipes/published'
import { Route as RecipesSlugIndexRouteImport } from './routes/recipes/$slug/index'
import { Route as RecipesSlugEditRouteImport } from './routes/recipes/$slug/edit'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const PantryRouteRoute = PantryRouteRouteImport.update({
  id: '/pantry',
  path: '/pantry',
  getParentRoute: () => rootRouteImport,
} as any)
const RecipesRouteRoute = RecipesRouteRouteImport.update({
  id: '/recipes',
  path: '/recipes',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsRoute = SettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => rootRouteImport,
} as any)
const ListListIdRoute = ListListIdRouteImport.update({
  id: '/list/$listId',
  path: '/list/$listId',
  getParentRoute: () => rootRouteImport,
} as any)
const PantryIndexRoute = PantryIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => PantryRouteRoute,
} as any)
const PantrySearchRoute = PantrySearchRouteImport.update({
  id: '/search',
  path: '/search',
  getParentRoute: () => PantryRouteRoute,
} as any)
const RecipesIndexRoute = RecipesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => RecipesRouteRoute,
} as any)
const RecipesSlugRouteRoute = RecipesSlugRouteRouteImport.update({
  id: '/$slug',
  path: '/$slug',
  getParentRoute: () => RecipesRouteRoute,
} as any)
const RecipesPublishedRoute = RecipesPublishedRouteImport.update({
  id: '/published',
  path: '/published',
  getParentRoute: () => RecipesRouteRoute,
} as any)
const RecipesSlugIndexRoute = RecipesSlugIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => RecipesSlugRouteRoute,
} as any)
const RecipesSlugEditRoute = RecipesSlugEditRouteImport.update({
  id: '/edit',
  path: '/edit',
  getParentRoute: () => RecipesSlugRouteRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/pantry': typeof PantryRouteRouteWithChildren
  '/recipes': typeof RecipesRouteRouteWithChildren
  '/settings': typeof SettingsRoute
  '/recipes/$slug': typeof RecipesSlugRouteRouteWithChildren
  '/list/$listId': typeof ListListIdRoute
  '/pantry/search': typeof PantrySearchRoute
  '/recipes/published': typeof RecipesPublishedRoute
  '/pantry/': typeof PantryIndexRoute
  '/recipes/': typeof RecipesIndexRoute
  '/recipes/$slug/edit': typeof RecipesSlugEditRoute
  '/recipes/$slug/': typeof RecipesSlugIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/settings': typeof SettingsRoute
  '/list/$listId': typeof ListListIdRoute
  '/pantry/search': typeof PantrySearchRoute
  '/recipes/published': typeof RecipesPublishedRoute
  '/pantry': typeof PantryIndexRoute
  '/recipes': typeof RecipesIndexRoute
  '/recipes/$slug/edit': typeof RecipesSlugEditRoute
  '/recipes/$slug': typeof RecipesSlugIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/pantry': typeof PantryRouteRouteWithChildren
  '/recipes': typeof RecipesRouteRouteWithChildren
  '/settings': typeof SettingsRoute
  '/recipes/$slug': typeof RecipesSlugRouteRouteWithChildren
  '/list/$listId': typeof ListListIdRoute
  '/pantry/search': typeof PantrySearchRoute
  '/recipes/published': typeof RecipesPublishedRoute
  '/pantry/': typeof PantryIndexRoute
  '/recipes/': typeof RecipesIndexRoute
  '/recipes/$slug/edit': typeof RecipesSlugEditRoute
  '/recipes/$slug/': typeof RecipesSlugIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/pantry'
    | '/recipes'
    | '/settings'
    | '/recipes/$slug'
    | '/list/$listId'
    | '/pantry/search'
    | '/recipes/published'
    | '/pantry/'
    | '/recipes/'
    | '/recipes/$slug/edit'
    | '/recipes/$slug/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/settings'
    | '/list/$listId'
    | '/pantry/search'
    | '/recipes/published'
    | '/pantry'
    | '/recipes'
    | '/recipes/$slug/edit'
    | '/recipes/$slug'
  id:
    | '__root__'
    | '/'
    | '/pantry'
    | '/recipes'
    | '/settings'
    | '/recipes/$slug'
    | '/list/$listId'
    | '/pantry/search'
    | '/recipes/published'
    | '/pantry/'
    | '/recipes/'
    | '/recipes/$slug/edit'
    | '/recipes/$slug/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  PantryRouteRoute: typeof PantryRouteRouteWithChildren
  RecipesRouteRoute: typeof RecipesRouteRouteWithChildren
  SettingsRoute: typeof SettingsRoute
  ListListIdRoute: typeof ListListIdRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/pantry': {
      id: '/pantry'
      path: '/pantry'
      fullPath: '/pantry'
      preLoaderRoute: typeof PantryRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/recipes': {
      id: '/recipes'
      path: '/recipes'
      fullPath: '/recipes'
      preLoaderRoute: typeof RecipesRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings': {
      id: '/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof SettingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/list/$listId': {
      id: '/list/$listId'
      path: '/list/$listId'
      fullPath: '/list/$listId'
      preLoaderRoute: typeof ListListIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/pantry/': {
      id: '/pantry/'
      path: '/'
      fullPath: '/pantry/'
      preLoaderRoute: typeof PantryIndexRouteImport
      parentRoute: typeof PantryRouteRoute
    }
    '/pantry/search': {
      id: '/pantry/search'
      path: '/search'
      fullPath: '/pantry/search'
      preLoaderRoute: typeof PantrySearchRouteImport
      parentRoute: typeof PantryRouteRoute
    }
    '/recipes/': {
      id: '/recipes/'
      path: '/'
      fullPath: '/recipes/'
      preLoaderRoute: typeof RecipesIndexRouteImport
      parentRoute: typeof RecipesRouteRoute
    }
    '/recipes/$slug': {
      id: '/recipes/$slug'
      path: '/$slug'
      fullPath: '/recipes/$slug'
      preLoaderRoute: typeof RecipesSlugRouteRouteImport
      parentRoute: typeof RecipesRouteRoute
    }
    '/recipes/published': {
      id: '/recipes/published'
      path: '/published'
      fullPath: '/recipes/published'
      preLoaderRoute: typeof RecipesPublishedRouteImport
      parentRoute: typeof RecipesRouteRoute
    }
    '/recipes/$slug/': {
      id: '/recipes/$slug/'
      path: '/'
      fullPath: '/recipes/$slug/'
      preLoaderRoute: typeof RecipesSlugIndexRouteImport
      parentRoute: typeof RecipesSlugRouteRoute
    }
    '/recipes/$slug/edit': {
      id: '/recipes/$slug/edit'
      path: '/edit'
      fullPath: '/recipes/$slug/edit'
      preLoaderRoute: typeof RecipesSlugEditRouteImport
      parentRoute: typeof RecipesSlugRouteRoute
    }
  }
}

interface PantryRouteRouteChildren {
  PantrySearchRoute: typeof PantrySearchRoute
  PantryIndexRoute: typeof PantryIndexRoute
}

const PantryRouteRouteChildren: PantryRouteRouteChildren = {
  PantrySearchRoute: PantrySearchRoute,
  PantryIndexRoute: PantryIndexRoute,
}

const PantryRouteRouteWithChildren = PantryRouteRoute._addFileChildren(
  PantryRouteRouteChildren,
)

interface RecipesSlugRouteRouteChildren {
  RecipesSlugEditRoute: typeof RecipesSlugEditRoute
  RecipesSlugIndexRoute: typeof RecipesSlugIndexRoute
}

const RecipesSlugRouteRouteChildren: RecipesSlugRouteRouteChildren = {
  RecipesSlugEditRoute: RecipesSlugEditRoute,
  RecipesSlugIndexRoute: RecipesSlugIndexRoute,
}

const RecipesSlugRouteRouteWithChildren =
  RecipesSlugRouteRoute._addFileChildren(RecipesSlugRouteRouteChildren)

interface RecipesRouteRouteChildren {
  RecipesSlugRouteRoute: typeof RecipesSlugRouteRouteWithChildren
  RecipesPublishedRoute: typeof RecipesPublishedRoute
  RecipesIndexRoute: typeof RecipesIndexRoute
}

const RecipesRouteRouteChildren: RecipesRouteRouteChildren = {
  RecipesSlugRouteRoute: RecipesSlugRouteRouteWithChildren,
  RecipesPublishedRoute: RecipesPublishedRoute,
  RecipesIndexRoute: RecipesIndexRoute,
}

const RecipesRouteRouteWithChildren = RecipesRouteRoute._addFileChildren(
  RecipesRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  PantryRouteRoute: PantryRouteRouteWithChildren,
  RecipesRouteRoute: RecipesRouteRouteWithChildren,
  SettingsRoute: SettingsRoute,
  ListListIdRoute: ListListIdRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
